import { forwardRef } from 'react';
import { Link, type LinkProps } from 'react-router-dom';

/**
 * The component prop of ListItemButton also forwards the ref to the component.
 * This wrapper is needed to forward the ref to the Link component.
 */
export const RouterLink = forwardRef<HTMLAnchorElement, LinkProps>(function RouterLink(props, ref) {
  return <Link ref={ref} {...props} />;
});
